export const overrides = theme => ({
  root: {
    fontSize: theme.typography.subtitle2.fontSize,
  },
})
